import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { API_URL } from '../config';
import { toast } from 'react-toastify';

function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setStatus('error');
            setMessage('No verification token found in the URL.');
            return;
        }

        const verifyToken = async () => {
            try {
                await axios.post(`${API_URL}/auth/verify`, { token });
                setStatus('success');
                setMessage('Your email has been verified successfully!');
                toast.success('Email verified! You can now log in.');
                
                // Redirect to login after 3 seconds
                setTimeout(() => navigate('/'), 3000);
            } catch (err) {
                setStatus('error');
                const errorMsg = err.response?.data?.message || 'Verification failed. The link may be expired or invalid.';
                setMessage(errorMsg);
                toast.error(errorMsg);
            }
        };

        verifyToken();
    }, [searchParams, navigate]);

    // Verifying View
    if (status === 'verifying') {
        return (
            <div className="auth-page">
                <div className="auth-card" style={{ textAlign: 'center', padding: '60px 40px' }}>
                    <div className="spinner" style={{ width: '32px', height: '32px', borderTopColor: '#fff', margin: '0 auto 24px' }}></div>
                    <h2 className="auth-title" style={{ marginBottom: '8px' }}>Verifying Email</h2>
                    <p className="auth-subtitle">Please wait while we verify your account...</p>
                </div>
            </div>
        );
    }

    // Success View
    if (status === 'success') {
        return (
            <div className="auth-page">
                <div className="auth-card" style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
                    <h2 className="auth-title" style={{ color: 'var(--success)', marginBottom: '12px' }}>
                        Email Verified!
                    </h2>
                    <p className="auth-subtitle" style={{ marginBottom: '32px' }}>
                        {message}
                    </p>
                    <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '32px' }}>
                        Redirecting to login...
                    </p>
                    <button onClick={() => navigate('/')} className="btn-primary" style={{ width: '100%' }}>
                        Go to Login Now
                    </button>
                </div>
            </div>
        );
    }

    // Error View
    return (
        <div className="auth-page">
            <div className="auth-card" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
                <h2 className="auth-title" style={{ color: 'var(--error)', marginBottom: '12px' }}>
                    Verification Failed
                </h2>
                <p className="auth-subtitle" style={{ marginBottom: '32px' }}>
                    {message}
                </p>
                <button onClick={() => navigate('/')} className="btn-primary" style={{ width: '100%' }}>
                    Back to Login
                </button>
                
                <div style={{ marginTop: '24px' }}>
                    <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                        Need a new link? <Link to="/register" style={{ color: 'var(--text)', fontWeight: '500', borderBottom: '1px solid var(--border-hover)' }}>Register again</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default VerifyEmail;